import request from './request'

/**
 * 取得共用設定檔選單數據資料
 * @param {string} typeCode
 * @returns {Promise} axios的Promise物件
 */
function getCmOptionEnum(typeCode) {
  return request({
    url: '/cmOptionEnum/getCmOptionEnum',
    method: 'get',
    params: { typeCode },
  })
}

export default { getCmOptionEnum }
